export const truncateString = (str: string, num: number) => {
  return str.length > num ? str.substring(0, num) + '...' : str;
};
